import styled from '@emotion/styled';
import {
    mediaQuery,
    fontSizes,
    breakpoints,
    colors,
    colorVariables,
} from '@gumtree/ui-library/src/base/theme';

export const CarouselContainer = styled.div`
    width: 100%;
    padding: 40px 0;
    background-color: ${colorVariables.backgroundNeutral};
    border-bottom: 1px solid ${colors.newBorder};
`;

export const CarouselTitle = styled.h2`
    margin-bottom: 0;
    color: ${colorVariables.textPrimary};

    font-weight: 600;
    font-size: ${fontSizes.xlarge};
    line-height: 32px;

    ${mediaQuery.from(breakpoints.large)} {
        font-size: ${fontSizes.pgLarge};
    }
`;

export const ScrollWrapper = styled.div`
    display: flex;
    overflow-x: auto;
    padding-top: 16px;
    /* padding-bottom: 8px; // 为滚动条留出空间，或者自定义滚动条样式 */

    /* 隐藏滚动条 (可选, 但在某些设计中很常见) */
    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */


    ${mediaQuery.from(breakpoints.medium)} {
        overflow-x: hidden;
    }
`;

export const ImageItem = styled.div`
    width: 300px;
    height: 250px;
    flex-shrink: 0;
    margin-right: 12px;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); // 类似卡片的效果
    position: relative;

    &:last-child {
        margin-right: 0;
    }

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px; // 如果ImageItem没有 overflow:hidden，则在此处设置
    }
`;

export const ImageItemOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); // 半透明黑色蒙层
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5em; // 根据需要调整字体大小
  font-weight: bold;
  pointer-events: none; // 允许点击穿透到图片本身（如果需要的话）
`;
